import React from 'react';
import { WarehouseRow } from './WarehouseRow';
import { PickupAddress } from '../types/address';

interface WarehouseListProps {
  warehouses: PickupAddress[];
}

export const WarehouseList: React.FC<WarehouseListProps> = ({
  warehouses,
}) => {
  if (!warehouses.length) {
    return (
      <div className="p-6 text-center text-gray-500">
        No warehouses found
      </div>
    );
  }

  return (
    <div className="divide-y">
      {warehouses.map((warehouse) => (
        <WarehouseRow
          key={warehouse.pickup_id}
          warehouse={warehouse}
        />
      ))}
    </div>
  );
};
